import { defineComponent as C, useTemplateRef as O, computed as I, capitalize as w, watch as W, onMounted as L, onBeforeUnmount as S, createBlock as r, openBlock as t, Teleport as D, createCommentVNode as s, withCtx as l, createVNode as u, normalizeClass as n, unref as o, resolveDynamicComponent as c, mergeProps as E, createElementBlock as m, renderSlot as p, createSlots as F, createElementVNode as h, toDisplayString as y, createTextVNode as M } from "vue";
import i from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/ModalBox/modal-box.js";
import f from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Backdrop/backdrop.js";
import N from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/layouts/Bullseye/bullseye.js";
import { c_modal_box_m_align_top_spacer as P } from "../../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_modal_box_m_align_top_spacer.js";
import R from "./ModalHeader.vue2.js";
import z from "../../helpers/PassThrough.vue2.js";
import A from "../Backdrop.vue2.js";
import U from "../../helpers/FocusTrap.vue2.js";
import q from "../Tooltip/Tooltip.vue2.js";
import j from "../CloseButton.vue2.js";
import { CircleCheckIcon as G } from "../../packages/icons/dist/esm/icons/circle-check-icon.js";
import { CircleExclamationIcon as H } from "../../packages/icons/dist/esm/icons/circle-exclamation-icon.js";
import { TriangleExclamationIcon as J } from "../../packages/icons/dist/esm/icons/triangle-exclamation-icon.js";
import { CircleInfoIcon as K } from "../../packages/icons/dist/esm/icons/circle-info-icon.js";
import { BellIcon as Q } from "../../packages/icons/dist/esm/icons/bell-icon.js";
import { useElementOverflow as X } from "../../use/index.js";
import { useOUIAProps as Y } from "../../helpers/ouia.js";
const Z = {
  key: 1,
  class: "pf-v6-screen-reader"
}, _ = ["id"], ke = /* @__PURE__ */ C({
  name: "PfModal",
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    open: { type: Boolean },
    noClose: { type: Boolean },
    noBodyWrapper: { type: Boolean },
    disableFocusTrap: { type: Boolean },
    elementToFocus: {},
    title: {},
    titleLabel: {},
    titleIconVariant: {},
    appendTo: {},
    ariaDescribedby: {},
    variant: { default: "default" },
    width: {},
    maxWidth: {},
    position: { default: "default" },
    positionOffset: {},
    descriptorId: {},
    component: { default: "div" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["update:open"],
  setup(B, { emit: T }) {
    const a = B, $ = Y({ id: a.ouiaId, safe: a.ouiaSafe }), V = T, g = O("titleRef"), b = X(g), d = I(() => typeof a.appendTo == "function" ? a.appendTo() : typeof a.appendTo == "string" ? document.querySelector(a.appendTo) ?? document.body : a.appendTo ?? document.body), v = I(() => !a.titleLabel && a.titleIconVariant ? `${w(a.titleIconVariant)} alert:` : a.titleLabel);
    return W(() => a.open, () => {
      a.open ? d.value.classList.add(f.backdropOpen) : d.value.classList.remove(f.backdropOpen);
    }), L(() => {
      a.open ? d.value.classList.add(f.backdropOpen) : d.value.classList.remove(f.backdropOpen);
    }), S(() => {
      d.value.classList.remove(f.backdropOpen);
    }), (e, k) => (t(), r(D, { to: d.value }, [
      e.open ? (t(), r(A, { key: 0 }, {
        default: l(() => [
          u(U, {
            class: n(o(N).bullseye),
            active: !e.disableFocusTrap,
            "focus-trap-options": {
              clickOutsideDeactivates: !0,
              tabbableOptions: { displayCheck: "none" },
              // FocusTrap's initialFocus can accept false as a value to prevent initial focus.
              // We want to prevent this in case false is ever passed in.
              initialFocus: e.elementToFocus || void 0
            }
          }, {
            default: l(() => [
              (t(), r(c(e.component), E({ ...o($), ...e.$attrs }, {
                role: "dialog",
                "aria-describedby": e.ariaDescribedby || (e.noBodyWrapper ? null : e.descriptorId),
                "aria-modal": "true",
                class: [
                  o(i).modalBox,
                  e.titleIconVariant && e.titleIconVariant !== "default" && o(i).modifiers[e.titleIconVariant],
                  {
                    [o(i).modifiers.alignTop]: e.position === "top",
                    [o(i).modifiers.lg]: e.variant === "large",
                    [o(i).modifiers.sm]: e.variant === "small",
                    [o(i).modifiers.md]: e.variant === "medium"
                  }
                ],
                style: {
                  "--pf-v6-c-modal-box--Width": e.width ? typeof e.width != "number" ? e.width : `${e.width}px` : void 0,
                  "--pf-v6-c-modal-box--MaxWidth": e.maxWidth ? typeof e.maxWidth != "number" ? e.maxWidth : `${e.maxWidth}px` : void 0,
                  [o(P).name]: e.positionOffset
                }
              }), {
                default: l(() => [
                  e.noClose ? s("", !0) : (t(), m("div", {
                    key: 0,
                    class: n(o(i).modalBoxClose)
                  }, [
                    u(j, {
                      onClick: k[0] || (k[0] = (x) => V("update:open", !1))
                    })
                  ], 2)),
                  u(R, null, {
                    help: l(() => [
                      p(e.$slots, "help")
                    ]),
                    default: l(() => [
                      p(e.$slots, "header", {}, () => [
                        e.title ? (t(), r(c(o(b) ? q : z), { key: 0 }, F({
                          default: l(() => [
                            h("h1", {
                              ref: "titleRef",
                              class: n([o(i).modalBoxTitle, {
                                [o(i).modifiers.icon]: e.titleIconVariant
                              }])
                            }, [
                              e.titleIconVariant ? (t(), m("span", {
                                key: 0,
                                class: n(o(i).modalBoxTitleIcon)
                              }, [
                                e.titleIconVariant === "success" ? (t(), r(o(G), { key: 0 })) : e.titleIconVariant === "danger" ? (t(), r(o(H), { key: 1 })) : e.titleIconVariant === "warning" ? (t(), r(o(J), { key: 2 })) : e.titleIconVariant === "info" ? (t(), r(o(K), { key: 3 })) : e.titleIconVariant === "default" ? (t(), r(o(Q), { key: 4 })) : p(e.$slots, "title-icon", { key: 5 })
                              ], 2)) : s("", !0),
                              v.value ? (t(), m("span", Z, y(v.value), 1)) : s("", !0),
                              h("span", {
                                class: n(o(i).modalBoxTitleText)
                              }, y(e.title), 3)
                            ], 2)
                          ]),
                          _: 2
                        }, [
                          o(b) ? {
                            name: "content",
                            fn: l(() => [
                              M(y(e.title), 1)
                            ]),
                            key: "0"
                          } : void 0
                        ]), 1024)) : s("", !0),
                        e.$slots.description ? (t(), m("div", {
                          key: 1,
                          id: e.descriptorId,
                          class: n(o(i).modalBoxDescription)
                        }, [
                          p(e.$slots, "description")
                        ], 10, _)) : s("", !0)
                      ])
                    ]),
                    _: 3
                  }),
                  (t(), r(c(e.noBodyWrapper ? "pass-through" : "div"), {
                    id: e.$slots.description || e.ariaDescribedby ? null : e.descriptorId,
                    class: n(o(i).modalBoxBody)
                  }, {
                    default: l(() => [
                      p(e.$slots, "default")
                    ]),
                    _: 3
                  }, 8, ["id", "class"])),
                  e.$slots.footer ? (t(), m("footer", {
                    key: 1,
                    class: n(o(i).modalBoxFooter)
                  }, [
                    p(e.$slots, "footer")
                  ], 2)) : s("", !0)
                ]),
                _: 3
              }, 16, ["aria-describedby", "class", "style"]))
            ]),
            _: 3
          }, 8, ["class", "active", "focus-trap-options"])
        ]),
        _: 3
      })) : s("", !0)
    ], 8, ["to"]));
  }
});
export {
  ke as default
};
